import {
  InstallExtensionButton,
  InstallExtensionInstructions,
} from 'shared/add-babylist-button'
import Slide, { Title } from '../../Slide/Slide'
import css from './InstallExtension.scss'
import classnames from 'classnames'
import Link from 'components/link'
import QuoteSymbol from 'shared/svg/quote-symbol.svg'

const InstallExtension = () => {
  return (
    <Slide>
      <div className={css.InstallExtension__container}>
        <div className={css.InstallExtension__topContainer}>
          <div className={css.InstallExtension__headerContainer}>
            <Title className={css.InstallExtension__title}>
              Real quick! Install the Babylist Button to add items to your
              registry
            </Title>

            <p className={css.InstallExtension__subtext}>
              Our Chrome extension lets you add items to your registry from any
              website.
            </p>
          </div>

          <InstallExtensionButton
            className={classnames(
              'btn-shadow animated bounce delay-4500ms',
              css.InstallExtension__installExtensionButton
            )}
            showChromeLogo={false}
            buttonText="Add to Chrome"
          />
        </div>

        <InstallExtensionInstructions className={css.InstallExtension__image} />

        <div className={css.InstallExtension__quoteContainer}>
          <div className={css.InstallExtension__quoteIconContainer}>
            <QuoteSymbol className={css.InstallExtension__quoteIcon} />
          </div>
          <p className={css.InstallExtenstion__quote}>
            &ldquo;I love the Babylist Button and being able to add virtually
            anything to our registry. It&rsquo;s so helpful and makes our
            registry more well-rounded and more &lsquo;us.&rsquo;&rdquo;
          </p>
        </div>

        <Link className={css.InstallExtension__skipLink} url="/registry/home">
          Take me to my registry
        </Link>
      </div>
    </Slide>
  )
}

export default InstallExtension
